export const USER_DEVICE = {
  os: 'web',
};
